import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/slider-double/slider-double.js';
      import {ObcSliderDoubleValueEvent, ObcSliderDoubleVariant} from '@oicl/openbridge-webcomponents/dist/components/slider-double/slider-double.js';

      export interface Props {
     low?: number;
     high?: number;
     min?: number;
     max?: number;
     step?: number | undefined;
     stepClick?: number;
     variant?: ObcSliderDoubleVariant;
     allowSeeking?: boolean;
     disabled?: boolean;
     seekingSpeed?: number;
     labelUnit?: string;
     labelDecimals?: number;
     labelWidth?: string
   }

      
  
      export type {ObcSliderDoubleValueEvent, ObcSliderDoubleVariant} from '@oicl/openbridge-webcomponents/dist/components/slider-double/slider-double.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcSliderDouble',
  props: {
    low: {},
    high: {},
    min: {},
    max: {},
    step: {},
    stepClick: {},
    variant: {},
    allowSeeking: { type: Boolean },
    disabled: { type: Boolean },
    seekingSpeed: {},
    labelUnit: {},
    labelDecimals: {},
    labelWidth: {}
  },
  emits: ["value"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onValue: (event: ObcSliderDoubleValueEvent) => emit('value', event as ObcSliderDoubleValueEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-slider-double',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})